import { render } from "./ProductMergeDialog.vue?vue&type=template&id=ba9d3eca&scoped=true"
import script from "./ProductMergeDialog.vue?vue&type=script&lang=js"
export * from "./ProductMergeDialog.vue?vue&type=script&lang=js"

import "./ProductMergeDialog.vue?vue&type=style&index=0&id=ba9d3eca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba9d3eca"]])

export default __exports__